import { createContext, useContext } from 'react';

import type { StripeElements } from '@stripe/stripe-js';

export const StripeElementsContext = createContext<StripeElements | undefined>(
  undefined
);

/** Return the elements context value */
export function useStripeElements() {
  return useContext(StripeElementsContext);
}
